import './OpenAccount.css';

const OpenAccount = () => {
  return (
    <section className="open-account">
      <div className="open-account-container">
        <h2 className="open-account-title">Open Live Account</h2>
        <p className="open-account-description">
          Explore the world of trading by opening a Live Account with tredixo.store.
          We have incredible features designed for success.
        </p>
        <button className="btn-open-account" onClick={() => window.open('https://web.theplatformapi.com/create-company-user?companyName=TREDIXO&isDemo=false&parentId=6', '_blank')}>Open LIVE Account</button>
      </div>
    </section>
  );
};

export default OpenAccount;
